import axios from 'axios';
import { Dispatch } from 'redux';
import { omit } from 'lodash';
import { createAction } from '@reduxjs/toolkit';

import { responseEntityMapper } from '@qwealth/qcore';
import { apiUrl, QNote } from '@qwealth/qdata';
import { uploadFiles } from '@qwealth/qvault';

import { errorHandler } from '../../services/axiosService';
import { getHouseholdQNotes } from '../data-layer/qnote';
import { getQnoteAttachmentPath } from 'data/helpers/qnoteFilterHelper';

const PUT_HOUSEHOLD_QNOTES = 'PUT_HOUSEHOLD_QNOTES';
const ADD_HOUSEHOLD_QNOTE = 'ADD_HOUSEHOLD_QNOTE';
const DELETE_HOUSEHOLD_QNOTE = 'DELETE_HOUSEHOLD_QNOTE';

export const putHouseholdQNotes = createAction<Array<QNote>>(PUT_HOUSEHOLD_QNOTES);
export const addHouseholdQNote = createAction<QNote>(ADD_HOUSEHOLD_QNOTE);
export const deleteHouseholdQnote = createAction<string>(DELETE_HOUSEHOLD_QNOTE);

export const loadHouseholdNotes =
  (householdId: string) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      const qnotes = await getHouseholdQNotes(householdId);
      dispatch(putHouseholdQNotes(qnotes));
    } catch (error) {
      errorHandler(dispatch, 'Could not load household notes')(error);
    }
  };

export const saveQNote =
  qnote =>
  (dispatch: Dispatch): Promise<void> => {
    const { pending, uuid, householdQID } = qnote;
    const noteContent = qnote.noteContent;
    const payload = {
      ...omit(qnote, ['attachments', 'pending']),
      content: noteContent,
    };
    const saveFn = qnote.uuid ? axios.patch(`${apiUrl}/qnotes/${uuid}`, payload) : axios.post(`${apiUrl}/qnotes`, payload);
    return saveFn
      .then(response => responseEntityMapper<QNote>(response))
      .then(async savedNote => {
        dispatch(addHouseholdQNote(savedNote));
        if (pending && savedNote.uuid && householdQID) {
          const path = getQnoteAttachmentPath(householdQID, savedNote.uuid);
          await uploadFiles(pending, path);
        }
      })
      .catch(errorHandler(dispatch, 'Could not save QNote, please contact technology@qwealth.com.'));
  };

export const deleteQNote =
  (uuid: string) =>
  (dispatch: Dispatch): Promise<void> =>
    axios
      .delete(`${apiUrl}/qnotes/${uuid}`)
      .then(() => {
        dispatch(deleteHouseholdQnote(uuid));
      })
      .catch(errorHandler(dispatch, 'Could not delete QNote, please contact technology@qwealth.com.'));
